window.addEventListener("load", function () {
  var $carousel = document.querySelector("#Frame6 .carousel");
  if (!$carousel) return;
  if (typeof Swiper === "undefined") return;

  function hideEdgeSlides(sw) {
    var keepEachSide = window.matchMedia("(max-width: 768px)").matches ? 1 : 2;
    sw.slides.forEach(function (s) {
      s.style.visibility =
        Math.abs(s.progress) > keepEachSide + 0.5 ? "hidden" : "";
    });
  }

  new Swiper($carousel, {
    effect: "coverflow",
    centeredSlides: true,
    slidesPerView: "auto",
    loop: true,
    watchSlidesProgress: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 210,
      depth: 300,
      modifier: 0.8,
      slideShadows: false,
    },
    breakpoints: {
      0: {
        coverflowEffect: {
          rotate: 0,
          stretch: 140,
          depth: 900,
          modifier: 1,
          slideShadows: false,
        },
      },
      769: {
        coverflowEffect: {
          rotate: 0,
          stretch: 210,
          depth: 300,
          modifier: 0.8,
          slideShadows: false,
        },
      },
    },
    navigation: {
      prevEl: "#Frame6 .prev",
      nextEl: "#Frame6 .next",
    },
    pagination: {
      el: "#Frame6 .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return (
          '<span class="' + className + " dot dot-" + (index + 1) + '"></span>'
        );
      },
    },
    on: {
      init: hideEdgeSlides,
      setTranslate: hideEdgeSlides,
      setTransition: hideEdgeSlides,
    },
  });
});
